
import {defineComponent} from "vue";
import InputCheckboxBoolean from "@/components/UI/InputCheckboxBoolean.vue";

export default defineComponent({
  name: "MetadataGroupCard",
  components: {InputCheckboxBoolean},
  emits: ['update:enabled', 'reset'],
  props: {
    // Title shown next to the on/off switch, e.g. "Afronding".
    title: {
      type: String,
      required: true,
    },
    enabled: {
      type: Boolean,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
});
